module.exports = __webpack_public_path__ + "img/font-solid.b39573bf.svg";